import {Currency, CurrencyProviderService} from '../../service';
import {Component, OnInit} from '@angular/core';
import {ComponentHelper, FormBaseComponent, ValidationPattern, ValidatorService} from '@utils-lib';
import {AppNameEnum, GrundStammkapitalAngabe} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {DatevMessageService} from '@datev/ngx-ui-components';
import {ActivatedRoute} from '@angular/router';
import {isEmpty} from 'lodash';

const MAX_LENGTH_GELDBETRAG = 12;

@Component({
    selector: 'common-ui-hoehe-grund-stammkapital-angabe',
    templateUrl: './hoehe-grund-stammkapital-angabe.component.html',
    styleUrls: ['./hoehe-grund-stammkapital-angabe.component.scss']
})
export class HoeheGrundStammkapitalAngabeComponent extends FormBaseComponent<GrundStammkapitalAngabe> implements OnInit {

    public isKapGAus = false;
    public mainCurrencies = Array<Currency>();
    public otherCurrencies = Array<Currency>();

    constructor(
        private readonly formBuilder: FormBuilder,
        private readonly validatorService: ValidatorService,
        private readonly translateService: TranslateService,
        protected readonly messageService: DatevMessageService,
        protected readonly activatedRoute: ActivatedRoute,
        private readonly currencyProvider: CurrencyProviderService) {
        super(messageService);
    }

    public ngOnInit(): void {
        super.ngOnInit();
        this.mainCurrencies = this.currencyProvider.getMainCurrencyList();
        this.otherCurrencies = this.currencyProvider.getOtherCurrencyList();

        const appEnum = ComponentHelper.getAppEnum(this.activatedRoute.snapshot);
        if (appEnum === AppNameEnum.FragebogenKapGAus) {
            this.isKapGAus = true;
        }
    }

    public validateDaraufEingezahlt(): boolean {

        const daraufEingezahlt = Number(this.data.daraufEingezahlt);
        const hoeheGrundStammkapital = Number(this.data.hoeheGrundStammkapital);

        const eingezahltIsNaNOrZero = isNaN(daraufEingezahlt) || daraufEingezahlt === 0;
        const hoeheIsNaNOrZero = isNaN(hoeheGrundStammkapital) || hoeheGrundStammkapital === 0;

        // eingezahlt > hoehe
        if (!eingezahltIsNaNOrZero && !hoeheIsNaNOrZero && daraufEingezahlt > hoeheGrundStammkapital) {
            return false;
        }
        // eingezahlt > 0 && hoehe is NaNOrZero
        return !(!eingezahltIsNaNOrZero && daraufEingezahlt > 0 && hoeheIsNaNOrZero);
    }

    protected createForm(): void {
        this.form = this.formBuilder.group({
            hoeheGrundStammkapital: [
                this.data.hoeheGrundStammkapital, [
                    this.validatorService.required(),
                    this.validatorService.maxLength(MAX_LENGTH_GELDBETRAG),
                    this.validatorService.pattern(ValidationPattern.VOLLER_POSITIVER_GELDBETRAG,
                        this.translateService.instant('COMMON_UI.VALIDATION.VOLLER_POSITIVER_GELDBETRAG_PATTERN'))
                ]],

            daraufEingezahlt: [
                this.data.daraufEingezahlt, [
                    this.validatorService.maxLength(MAX_LENGTH_GELDBETRAG),
                    this.validatorService.conditionTrue(() =>
                            this.validateDaraufEingezahlt(),
                        this.translateService.instant('COMMON_UI.VALIDATION.EINGEZAHLTES_GRUNDKAPITAL_HOEHE')
                    ),
                    this.validatorService.pattern(ValidationPattern.VOLLER_POSITIVER_GELDBETRAG,
                        this.translateService.instant('COMMON_UI.VALIDATION.VOLLER_POSITIVER_GELDBETRAG_PATTERN')
                    )
                ]],
            hoeheGrundStammkapitalWaehrungsangabe: [this.data.hoeheGrundStammkapitalWaehrungsangabe, [
                this.validatorService.maxLength(50),
                this.validatorService.conditionalValidator(() =>
                        !isEmpty(this.data.hoeheGrundStammkapital),
                    this.validatorService.required())
            ]],
            hoeheGrundStammkapitalWaehrungsangabeEnum: [this.data.hoeheGrundStammkapitalWaehrungsangabeEnum, [
                this.validatorService.conditionalValidator(() =>
                        !isEmpty(this.data.hoeheGrundStammkapital),
                    this.validatorService.required())
            ]],
            daraufEingezahltWaehrungsangabeEnum: [this.data.daraufEingezahltWaehrungsangabeEnum, [
                this.validatorService.conditionalValidator(() =>
                        !isEmpty(this.data.daraufEingezahlt),
                    this.validatorService.required())
            ]],
            daraufEingezahltWaehrungsangabe: [this.data.daraufEingezahltWaehrungsangabe, [
                this.validatorService.maxLength(50),
                this.validatorService.conditionalValidator(() =>
                        !isEmpty(this.data.daraufEingezahlt),
                    this.validatorService.required())
            ]]
        });
    }
}
